/**
 * 本地存储所用的key
 * */
export const REGISTER_REMEMBER_ME = 'REGISTER_REMEMBER_ME' // 注册系统, 记住用户信息 localStorage

/**
 * 根据mgType跳转到相应的平台登陆页面
 * 平台标示  0：物联网平台 1：车载设备平台  2：应用中心  3：CRM  4：在线差分工具
 * */
export const platformMap = [
    {
        key: 0, //0：物联网平台
        url: window.g.toIotUrl + '/Login',
    },
    {
        key: 1, //1：车载设备平台
        url: window.g.toIovUrl + '/Login',
    },
    {
        key: 2, //2：应用中心
        url: window.g.toIotAppUrl + '/#/Login',
    },
    {
        key: 3, //3：CRM
        url: window.g.toIotCrmUrl + '/#/login',
    },
    {
        key: 4, //4: 在线差分工具
        url: window.g.toIotRtosUrl + '/#/login',
    },
]

// APi服务器地址
export const SERVER_URL = `${window.g.baseApi}`
